module.exports = require('prop-types');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-proptypes/index.js
// module id = 6
// module chunks = 0